import React from 'react';

import { ActivityIndicator, View } from 'react-native';

import { useAutoSelectUrl } from 'hooks/use-autoselect-url/use-auto-select-url';

export default function AutoSelectScreen() {
  useAutoSelectUrl();

  // Show loading while the hook processes the parameters
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <ActivityIndicator size="large" />
    </View>
  );
}
